// import * as React from 'react';
import Container from '@mui/material/Container';
import WidgetsGrid from './WidgetsGrid.tsx';
// import AddchartIcon from '@mui/icons-material/Addchart';
// import PostAddIcon from '@mui/icons-material/PostAdd';
// import ReportIcon from '@mui/icons-material/Report';
// import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
// import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
// import RecentActorsIcon from '@mui/icons-material/RecentActors';
import FindResidentHeroSection from './FindResidentHeroSection';
import Footer from '../../components/footer/footer';
import theme from '@/theme.ts';
import { ThemeProvider } from '@mui/material';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type Props = {};

// eslint-disable-next-line no-empty-pattern
function DashboardPage({}: Props) {
  // const widgetsData = [
  //   {
  //     icon: <AddchartIcon fontSize="large" />,
  //     title: 'Export Jobs',
  //     route: 'ExportJobs',
  //     description: 'Find all previous export jobs',
  //   },
  //   {
  //     icon: <PostAddIcon fontSize="large" />,
  //     title: 'Saved Filters',
  //     route: 'SavedFilter',
  //     description: 'List of residents who were admitted in last 7 days.',
  //   },
  //   {
  //     icon: <ReportIcon fontSize="large" />,
  //     title: 'List 1',
  //     route: 'List1',
  //     description:
  //       'Select resident that need to be documented on today or past due',
  //   },
  //   {
  //     icon: <AssignmentIndIcon fontSize="large" />,
  //     title: 'List 2',
  //     route: 'SupervisorReview',
  //     description: 'List of residents that are flagged for review.',
  //   },
  //   {
  //     icon: <PublishedWithChangesIcon fontSize="large" />,
  //     title: 'List 3',
  //     route: 'Inactive',
  //     description: '',
  //   },
  //   {
  //     icon: <RecentActorsIcon fontSize="large" />,
  //     title: 'Help',
  //     route: 'RecentlyAssessed',
  //     description: 'Residents who are assessed recently',
  //   },
  // ];

  return (
    <ThemeProvider theme={theme}>
      <FindResidentHeroSection />
      <Container
        sx={{ maxHeight: 2, bgcolor: theme.palette.primary.main }}
        maxWidth={false}
      >
        &nbsp;
      </Container>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '80vh',
        }}
      >
        <WidgetsGrid widgets={[]} />
      </Container>
      <Footer />
    </ThemeProvider>
  );
}

export default DashboardPage;
